import React from "react";
import { UserRound, Shield } from "lucide-react";

const RoleToggle = ({ role, onChange }) => {
  return (
    <div
      className="
        flex
        h-[45px]
        w-full
        rounded-[10px]
        bg-[#f5f4f2]
        p-[3px]
      "
    >
      <button
        type="button"
        onClick={() => onChange("customer")}
        className={`
          flex
          flex-1
          items-center
          justify-center
          gap-2
          rounded-[8px]
          border-none
          font-['Inter']
          text-[12px]
          font-semibold
          transition-all

          ${
            role === "customer"
              ? `
                bg-white
                text-[#1e3440]
                shadow-[0_2px_7px_rgba(0,0,0,0.08)]
              `
              : `
                bg-transparent
                text-[#8a9197]
              `
          }
        `}
      >
        <UserRound
          size={15}
          className={role === "customer" ? "text-[#5e3194]" : ""}
        />
        Investor
      </button>

      <button
        type="button"
        onClick={() => onChange("owner")}
        className={`
          flex
          flex-1
          items-center
          justify-center
          gap-2
          rounded-[8px]
          border-none
          font-['Inter']
          text-[12px]
          font-semibold
          transition-all

          ${
            role === "owner"
              ? `
                bg-white
                text-[#1e3440]
                shadow-[0_2px_7px_rgba(0,0,0,0.08)]
              `
              : `
                bg-transparent
                text-[#8a9197]
              `
          }
        `}
      >
        <Shield
          size={15}
          className={role === "owner" ? "text-[#5e3194]" : ""}
        />
        Property Owner
      </button>
    </div>
  );
};

export default RoleToggle;
